import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { PANEL_TYPES } from '../../../shell/panel-state'
import '../../../modules/deals/register-panels'
import { DealFullPage } from '../../../modules/deals/deal-full-page'

const detailSearchSchema = z.object({
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
})

/** The full-page deal record at /deals/:id. */
export const Route = createFileRoute('/_authed/deals/$dealId')({
  validateSearch: detailSearchSchema,
  component: DealDetailRoute,
})

function DealDetailRoute() {
  const { dealId } = Route.useParams()
  return <DealFullPage dealId={dealId} />
}
